import Counter from '@components/Counter/Counter';

import {
  GuestInfoWrapper,
  GuestWrapper,
  GuestInfo,
  GuestSubtitle,
  GuestTextWrapper,
  GuestTitle,
} from './GuestStyle';
import { GuestProps } from './GuestInterface';

const Guest: React.FC<GuestProps> = ({
  title,
  subTitle,
  counterProps,
  renderDateInput = () => null,
}) => (
  <GuestWrapper>
    <>
      <GuestInfoWrapper>
        <GuestInfo>
          <GuestTextWrapper>
            <GuestTitle>{title}</GuestTitle>
            <br />
            <GuestSubtitle>{subTitle}</GuestSubtitle>
          </GuestTextWrapper>
        </GuestInfo>

        <Counter {...counterProps} />
      </GuestInfoWrapper>
      {renderDateInput()}
    </>
  </GuestWrapper>
);

export default Guest;

export { GuestInfoWrapper };
